import { defineMessages } from 'react-intl'

import { TYPE } from './constants'

export const typeMessages = defineMessages({
  [TYPE.MOBILE]: {
    id: 'sites.type.mobile',
    defaultMessage: 'Mobile'
  },
  [TYPE.FIXED]: {
    id: 'sites.type.fixed',
    defaultMessage: 'Fixed'
  }
})
